/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsCancelSerialNumber
 */
export interface MelcoModelsCancelSerialNumber {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCancelSerialNumber
     */
    comments?: string | null;
}

export function MelcoModelsCancelSerialNumberFromJSON(json: any): MelcoModelsCancelSerialNumber {
    return MelcoModelsCancelSerialNumberFromJSONTyped(json, false);
}

export function MelcoModelsCancelSerialNumberFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsCancelSerialNumber {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'comments': !exists(json, 'comments') ? undefined : json['comments'],
    };
}

export function MelcoModelsCancelSerialNumberToJSON(value?: MelcoModelsCancelSerialNumber | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'comments': value.comments,
    };
}


